/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it
import React from "react";
import Layout from "./src/components/Layout/Layout";
import Scripts from "./src/components/Layout/Scripts";
import { LocaleContext } from "./src/utils/context";

// Use the hyphen alias (swiper/element-bundle) rather than swiper/element/bundle.
// Gatsby 4's webpack 5 mishandles the nested subpath; the alias resolves to the same file.
import { register as registerSwiperElements } from "swiper/element-bundle";
registerSwiperElements();

export const wrapPageElement = ({
    element,
    props: {
        pageContext: {
            node_locale
        }
    }
}) => {
    return (
        <LocaleContext.Provider value={{ locale: node_locale }}>
            <Scripts />
            <Layout>{element}</Layout>
        </LocaleContext.Provider>
    )
}